<script>
  import acessosServico from '../servico';
    
  import "~componentes/../js/inspinia";

  import AcessosInscricaoForm from './compartilhado/AcessosInscricaoForm.vue';
  import AppFooter from '~componentes/Footer.vue';
  import VoltarAoTopo from '~componentes/VoltarAoTopo.vue';

  export default {
    components: { AppFooter, VoltarAoTopo, AcessosInscricaoForm },
    data() {
      return {
        acessoObjeto: {},
        carregando: true,
        filtros: this.camposFiltros(),
        configuracao: this.$storage.configuracao(),

        tipo: '',
        classImagem: '',
        rotaAnterior: '',
      }
    },
    methods: {
      camposFiltros() {
        return {
          idProjeto: '',
          idUnidade: '',
          idSolicitacaoCursosEventosServicos: '',
          pagina: 1,
          registrosPagina: 10000,
        };
      },
      carregar: function(id) {
        this.carregando = true;

        acessosServico
          .obterPorId(id)
          .then(acesso => {
            this.carregando = false;
            this.acessoObjeto = acesso;
          })
          .catch(erro => {
            this.carregando = false;             

            this.$router.push({ name: this.rotaAnterior });
          });
      },
      configuraTipo() {
        switch (this.$route.name) {
          case 'acessos.cursos-inscricao':
          case 'acessos.cursos-inscricao-linkdireto':
            this.tipo = 'CURSOS';
            this.classImagem = 'bannerRosto_interno_curso';
            this.rotaAnterior = 'acessos.cursos';
            break;
          case 'acessos.eventos-inscricao':
          case 'acessos.eventos-inscricao-linkdireto':
            this.tipo = 'EVENTOS'; 
            this.classImagem = 'bannerRosto_interno_evento';
            this.rotaAnterior = 'acessos.eventos';
            break;
          case 'acessos.doacoes-doar':
          case 'acessos.doacoes-doar-recorrente':
            this.tipo = 'DOAÇÕES';
            this.classImagem = 'bannerRosto_interno_doacao';
            this.rotaAnterior = 'acessos.doacoes';
            break;
          case 'acessos.licitacoes-detalhe':
            this.tipo = 'LICITAÇÕES';          
            this.rotaAnterior = 'acessos.licitacoes';
            break;
          default:
            this.$router.push('/acessos');
        }
      },
    },
    computed: {

    },
    created() {
      this.configuraTipo();

      this.carregar(this.$route.params.id);
    },
  }
</script>

<template>
  <div>
    <section id="sectionBanner"
             :class="'bannerRosto_interno ' + classImagem">

      <div id="texto-img" class="text-center">
        <h1 class="text-center">
          <strong>
            <span id="lblTipo">{{ tipo }}</span>
          </strong>
        </h1>
      </div>

    </section>

    <div class="container" style="padding-top:320px;">      
      <div v-if="!carregando">
          <acessos-inscricao-form :acessoObjeto="acessoObjeto" :idCript="this.$route.params.id" :idInscricaoDiretaCript="this.$route.params.idInscricaoDiretaCript">

          </acessos-inscricao-form>
      </div>      
    </div>
  </div>
</template>

<style scoped>
  @media (max-width: 100px) {
    .bannerRosto_interno {
        background-position-y: 0px;
    }
  }

  .bannerRosto_interno_curso {
    background: url('/img/acesso/banners/cursos.jpg');
  }

  .bannerRosto_interno_evento {
    background: url('/img/acesso/banners/eventos.jpg');
  }

  .bannerRosto_interno_servico {
    background: url('/img/acesso/banners/servicos.jpg');
  }

  .bannerRosto_interno_doacao {
    background: url('/img/acesso/banners/doacoes.jpg');
  }
  
  .bannerRosto_interno {    
    background-repeat: no-repeat;
    background-position: right -80px;
    overflow: hidden;
    background-size: cover;
    height: 50vh;
    animation-name: img-ani;
    animation-duration: 1s;
    animation-timing-function: ease-in;
    left: 0px;
    width: 100%;
    height: 300px;
    position: absolute;
  }

  .text-center {
    color:white;
    justify-content: center;
    padding-top: 40px;
    font-size: 35px;
  }

</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/acessos/componentes/AcessosInscricao.vue